import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    windowWidth: document.documentElement.clientWidth,
  },
  getters: {},
  mutations: {
    updateWindowWidth(state, payload) {
      state.windowWidth = document.documentElement.clientWidth;
    },
  },
  actions: {},
  modules: {},
});
